import { isPlatformBrowser } from '@angular/common';
import {
  Component, Inject, PLATFORM_ID, ViewEncapsulation
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BaseService } from '../../../../shared/services/base.service';
import { Popup, DialogData, PopupReq, IDPreview } from '../../../../shared/models/base';
import { UserService } from '../../../../shared/services/user.service';
import { PurchaseService } from '../../../../shared/services/purchase.service';
import { EnumStatusCode } from 'src/app/enum/enumStatusCode';
import { Router, ActivatedRoute } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators'
import { FundDetailReq, Comment, PDBranch, registerReq, ETFOrderFormInfo } from '../../../../shared/models/purchase';
import { AritcleService } from '../../../../shared/services/article.service';
import { ResponseArticleID, ArticledataID } from '../../../../shared/models/article';
import { mainData } from '../../../../shared/interface/main-data';
import { FundService } from '../../../../shared/services/fund.service';
import { FundSelectList, GetFundTypeRes, GetFundSelectListReq, GetFundSelectListRes } from '../../../../shared/models/fund';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RegisterComponent {
  isBrowser: boolean;
  captchaUrl = '';
  agreeChecked = false;
  disableagreeChecked = true;
  FundDetail = ['凱基商業銀行股份有限公司', '凱基商業銀行股份有限公司', '合作金庫銀行', '合作金庫銀行', '合作金庫銀行', '合作金庫銀行', '合作金庫銀行', '合作金庫銀行']
  scrWidth = 0;
  dialogData: DialogData = {} as DialogData;
  visible = false;
  visibleType = ''
  //警語彈窗
  dialogMsgData: DialogData[] = []; //警語彈窗
  visiblegMsg = false;
  popupData: Popup[] = [];
  UpdateTime: Popup[] = [];
  ETFMsgDate = '';
  ETFMsgUpdate = '';
  agreeTimes = 0;

  errorTest: string[] = [];
  errorFormat: string[] = [];
  CodeToken = '';
  FundNo = '';
  PDreq: FundDetailReq = {} as FundDetailReq;
  brokerageList: Comment[] = [];
  PDBranchList: PDBranch[] = [];
  request: registerReq = {} as registerReq;
  ETFOrderFormInfo: ETFOrderFormInfo = {} as ETFOrderFormInfo;
  OrderTime: boolean = false;
  TheOrderTime: boolean = true;
  //個資文章
  requestNew = new ResponseArticleID;
  aritcle: ArticledataID = {} as ArticledataID;

  //非登記時段時間
  EndDT = '';
  StartDT = '';
  PopupReq = new PopupReq;
  Alert = '';
  FundsSplit: boolean = false;
  privateType = 0;

  // 新增的屬性
  isSubscriptionPage: boolean = false;
  activeIndex: number = 0;

  // 基金類型列表
  fundTypeList: GetFundTypeRes[] = [];

  // 可交易基金列表 - 改為使用新的 interface
  canTradeFundList: GetFundSelectListRes[] = [];
  selectedCanTradeFund: GetFundSelectListRes = {} as GetFundSelectListRes;

  // 分別為每個 Tab 保存不同的基金列表
  fundListByType: { [typeId: number]: GetFundSelectListRes[] } = {};
  selectedFundByType: { [typeId: number]: GetFundSelectListRes } = {};

  iDPreview: IDPreview = {} as IDPreview;

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    private sanitizer: DomSanitizer,
    public baseService: BaseService,
    public userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    public purchaseService: PurchaseService,
    public aritcleService: AritcleService,
    public fundService: FundService,
    public mainData$: mainData
  ) {
    this.isBrowser = isPlatformBrowser(platformId);

    // 檢查是否為 subscription 路由
    this.isSubscriptionPage = this.router.url.includes('/etf/subscription');

    this.goTop();
    this.GetCaptchaImg();
    this.GetArticleByID();
    this.getETFMsg();
  }

 ngOnInit(): void {
  // 檢查是否為 subscription 路由
  this.isSubscriptionPage = this.router.url.includes('/etf/subscription');

  // 如果是 subscription 頁面，呼叫新的初始化方法
  if (this.isSubscriptionPage) {
    this.initializeSubscriptionPage();
  } else {
    // 處理非 subscription 頁面
    const fundId = this.route.snapshot.params['id'];
    if (fundId) {
      this.FundNo = fundId;
      this.request.FundNo = this.FundNo;
      this.GetPD();
      this.GetETFOrderFormInfo();
    }
  }
}


private initializeSubscriptionPage() {
  this.fundService.GetFundTypeListWithAvailableFund().subscribe(
    (typeRes) => {
      if (typeRes.StatusCode === EnumStatusCode.Success) {
        this.fundTypeList = typeRes.Entries.sort((a, b) => a.Sort - b.Sort);

        // 使用 combineLatest 等待所有基金列表載入完成
        const fundListRequests = this.fundTypeList.map(fundType =>
          this.fundService.GetFundsByType({ TypeID: fundType.Id })
        );

        if (fundListRequests.length > 0) {
          combineLatest(fundListRequests).subscribe(
            (fundLists) => {
              fundLists.forEach((listRes, index) => {
                const fundType = this.fundTypeList[index];
                if (listRes.StatusCode === EnumStatusCode.Success) {
                  this.fundListByType[fundType.Id] = listRes.Entries;
                  if (listRes.Entries.length > 0) {
                    this.selectedFundByType[fundType.Id] = listRes.Entries[0];
                  }
                }
              });
              // 所有基金都載入完成後，才處理 URL 參數
              this.handleSubscriptionParams(this.route.snapshot.queryParams);
            },
            (error) => {
              console.error('Failed to load fund lists:', error);
              this.handleSubscriptionParams(this.route.snapshot.queryParams);
            }
          );
        } else {
          // 沒有基金類型，直接處理 URL 參數
          this.handleSubscriptionParams(this.route.snapshot.queryParams);
        }
      } else {
        console.error('Failed to load fund types:', typeRes);
        this.handleSubscriptionParams(this.route.snapshot.queryParams);
      }
    },
    (error) => {
      console.error('API call failed for fund types:', error);
      this.handleSubscriptionParams(this.route.snapshot.queryParams);
    }
  );
}

  selectListChange(e: any) {
    this.request.PDealerID = e.value.ID;
    this.GetPDBranch(e.value.ID)
  }

  selectBranchListChange(e: any) {
    this.request.PDBranchCode = e.value.Code;
  }

  // 處理subscription頁面的URL參數
// handleSubscriptionParams()
handleSubscriptionParams(params: any) {
    const typeId = params['typeId'] ? parseInt(params['typeId']) : null;
    const fundId = params['fundId'] ? params['fundId'] : null;

    // 檢查是否有 URL 參數
    if (typeId) {
        this.setActiveTabAndFund(typeId, fundId);
    } else if (this.fundTypeList.length > 0) {
        // 如果沒有 URL 參數，預設選擇第一個類別和基金
        const defaultTypeId = this.fundTypeList[0].Id;
        const defaultFundId = this.fundListByType[defaultTypeId]?.[0]?.FundNo;
        this.setActiveTabAndFund(defaultTypeId, defaultFundId);
    }
}

  // 設定活躍的Tab
  setActiveTab(typeId: number) {
    const tabIndex = this.fundTypeList.findIndex(ft => ft.Id === typeId);
    if (tabIndex >= 0) {
      this.activeIndex = tabIndex;
      const currentFundType = this.fundTypeList[tabIndex];

      console.log('設定活躍Tab:', currentFundType); // 調試用

      // 更新當前顯示的基金列表
      this.canTradeFundList = this.fundListByType[currentFundType.Id] || [];

      if (this.canTradeFundList.length > 0) {
        this.selectedCanTradeFund = this.selectedFundByType[currentFundType.Id] || this.canTradeFundList[0];
        this.selectedFundByType[currentFundType.Id] = this.selectedCanTradeFund;
        this.loadFundData(this.selectedCanTradeFund);
      } else {
        // 如果沒有基金，也要更新URL
        this.updateUrlParams();
      }
    }
  }

  // 設定活躍的Tab和基金
setActiveTabAndFund(typeId: number, fundId: string) {
  const tabIndex = this.fundTypeList.findIndex(ft => ft.Id === typeId);
  if (tabIndex >= 0) {
    this.activeIndex = tabIndex;
    const currentFundType = this.fundTypeList[tabIndex];

    // 更新當前顯示的基金列表
    this.canTradeFundList = this.fundListByType[currentFundType.Id] || [];

    // 尋找對應的基金
    const targetFund = this.canTradeFundList.find(fund => fund.FundNo === fundId);
    if (targetFund) {
      // 找到指定基金，使用它
      this.selectedCanTradeFund = targetFund;
    } else if (this.canTradeFundList.length > 0) {
      // 找不到指定基金，但有其他基金，則選第一個
      this.selectedCanTradeFund = this.canTradeFundList[0];
    } else {
      // 該類別下沒有任何基金
      this.selectedCanTradeFund = {} as GetFundSelectListRes;
    }

    // 更新選單狀態並載入資料
    if (this.selectedCanTradeFund && this.selectedCanTradeFund.FundNo) {
      this.selectedFundByType[currentFundType.Id] = this.selectedCanTradeFund;
      this.loadFundData(this.selectedCanTradeFund);
    } else {
      // 沒有可選擇的基金，清除相關資料
      this.FundNo = '';
      this.request.FundNo = '';
      this.brokerageList = [];
      this.PDBranchList = [];
    }
  }
}

  // 更新URL參數
  updateUrlParams() {
    if (this.isSubscriptionPage && this.fundTypeList.length > this.activeIndex) {
      const currentFundType = this.fundTypeList[this.activeIndex];
      const queryParams: any = {
        typeId: currentFundType.Id
      };

      if (this.selectedCanTradeFund && this.selectedCanTradeFund.FundNo) {
        queryParams.fundId = this.selectedCanTradeFund.FundNo;
      }

      console.log('更新URL參數:', queryParams); // 調試用

      // 更新URL但不觸發路由導航
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'replace', // 改為replace，完全替換query參數
        replaceUrl: true // 使用replaceUrl避免在瀏覽器歷史中創建新條目
      }).then(() => {
        console.log('URL更新成功，當前URL:', this.router.url);
      }).catch(err => {
        console.error('URL更新失敗:', err);
      });
    }
  }

  //驗證碼API
  GetCaptchaImg() {
    this.userService.GetCaptchaImg().subscribe((res) => {
      if (res.StatusCode == EnumStatusCode.Success) {
        this.captchaUrl = res.Entries.Base64;
        this.request.CodeToken = res.Entries.Token;
      }
    });
    this.mainData$.loading$.next(false);
  }
  //驗證碼
  getSanitizedUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  //取得參與券商
  GetPD() {
    this.PDreq.FundNo = this.FundNo;
    this.purchaseService.GetPD(this.PDreq).subscribe((res) => {
      if (res.StatusCode == EnumStatusCode.Success) {
        this.brokerageList = res.Entries;
        if (this.brokerageList.length) {
          //預設第一筆取得子選單
          this.selectListChange({
            value: {
              ID: this.brokerageList[0].ID,
              Name: this.brokerageList[0].Name
            }
          })
        }
      }
    });
  }

  //券商分點/分公司代碼
  GetPDBranch(pId: number) {
    this.purchaseService.GetPDBranch(pId).subscribe((res) => {
      if (res.StatusCode == EnumStatusCode.Success) {
        this.PDBranchList = res.Entries;
        if (this.PDBranchList.length && !this.PDBranchList[0].NoChild) {
          this.request.PDBranchCode = this.PDBranchList[0].Code;
        } else {
          this.request.PDBranchCode = ''
        }
      }
      this.mainData$.loading$.next(false);
    })
  }

  //申購登記需求單表單資訊
  GetETFOrderFormInfo() {
    this.purchaseService.GetETFOrderFormInfo(this.PDreq).subscribe((res) => {
      if (res.StatusCode == EnumStatusCode.Success) {
        this.OrderTime = true;
        this.TheOrderTime = true;
        this.ETFOrderFormInfo = res.Entries;
        // if (this.PDBranchList.length) {
        //   this.request.PDBranchCode = this.PDBranchList[0].Code;
        // }
      } else {
        this.OrderTime = false;
        this.TheOrderTime = false;
        this.EndDT = res.Entries.EndDT;
        this.StartDT = res.Entries.StartDT;
        this.FundsSplit = res.Entries.FundsSplit;
        this.Alert = res.Entries.Alert;
      }
      this.mainData$.loading$.next(false);
    })

  }

  getWidth(i: number) {
    this.scrWidth = window.innerWidth;
    if (this.scrWidth > 820) {
      if (this.brokerageList && i === this.brokerageList?.length - 1) {
        let num = this.brokerageList && this.brokerageList?.length % 3
        if (num == 1) return '100%';
        else if (num) return 'calc(100% / 3 * 2)';
        else return 'calc(100% / 3)'
      } else return 'calc(100% / 3)'
    } else if (this.scrWidth > 640) {
      return '50%'
    } else return '100%'
  }

  visibleChange(e: any) {
    this.visible = false;
    if (e && this.visibleType === 'agreeChecked')
      this.agreeChecked = true;
      this.disableagreeChecked = false;
    this.GetETFOrderFormInfo();
  }

  getETFMsg() {
    // ETF警語
    this.ETFMsgDate = localStorage.getItem('ETFregisterMsg') || ''
    this.GetPopup();
  }

  GetPopup() {
    this.baseService.GetPopup(this.PopupReq).subscribe((res) => {
      if (res.StatusCode == EnumStatusCode.Success) {
        this.popupData = res.Entries;
        this.UpdateTime = this.popupData.sort(function (a, b) {
          let timeA: string = '';
          let timeB: string = '';
          timeA = a.UpdateTime;
          timeB = b.UpdateTime;

          if (timeA < timeB) {
            return 1;
          }
          if (timeA > timeB) {
            return -1;
          }
          return 0;
        })
        this.ETFMsgUpdate = localStorage.getItem('ETFMsgregisterUpdate') || ''
        if ((!this.ETFMsgDate || this.baseService.getTimeout0hour(this.ETFMsgDate)) || (this.UpdateTime.length && this.ETFMsgUpdate !== this.UpdateTime[0].UpdateTime)) {
          this.OpenDialog();
        }
      }
    });
  }

  OpenDialog() {
    if (this.isBrowser) this.visiblegMsg = true;
    this.dialogMsgData = this.popupData.map(val => {
      return {
        title: val.Title,
        message: val.Content,
        data: val
      }
    });
  }

  //警語彈窗
  visibleMsgChange(e: any) {
    if (e) this.agreeTimes = this.agreeTimes + 1;
    if (this.agreeTimes == this.popupData.length || (this.agreeTimes === 3)) {
      localStorage.setItem('ETFregisterMsg', new Date().toString());
      if (this.UpdateTime.length) localStorage.setItem('ETFMsgregisterUpdate', this.UpdateTime[0].UpdateTime)
    }
  }

  submitCheck() {
    this.errorTest = [];
    this.errorFormat = [];
    this.dialogData.message = ''
    if (!this.request.Name || !/^\s*\S/.test(this.request.Name)) {
      this.errorTest.push('姓名');
    }

    if (!this.request.IDNumber || !/^\s*\S/.test(this.request.IDNumber)) {
      this.errorTest.push('身份證字號/統編/外資法人');
    }

    if (this.request.IDNumber && !/^[A-Z][12]\d{8}$/.test(this.request.IDNumber) && !/^[0-9]{8}$/.test(this.request.IDNumber) && !/^F\d{8}$/.test(this.request.IDNumber)) {
      this.errorFormat.push('身份證字號/統編/外資法人');
    }

    if (!this.request.Email || !/^\s*\S/.test(this.request.Email)) {
      this.errorTest.push('E-mail');
    }

    if (this.request.Email && !/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(this.request.Email)) {
      this.errorFormat.push('E-mail');
    }
    if (!this.request.Phone || !/^\s*\S/.test(this.request.Phone)) {
      this.errorTest.push('聯絡電話');
    }
    if (this.request.Phone && !/^(09\d{8}|(?!09|00|01)(\d{2,4})\d{7,8})$/.test(this.request.Phone)) {
      this.errorFormat.push('聯絡電話');
    }

    if (!this.request.PDealerID) {
      this.errorTest.push('參與券商');
    }

    if (!this.request.PDBranchCode) {
      this.errorTest.push('券商分點/分公司代碼');
    }

    if (!this.request.PurchaseQuantity) {
      this.errorTest.push('擬申購組數');
    }

    if (!this.request.Code) {
      this.errorTest.push('驗證碼');
    }

    if (!this.agreeChecked) {
      this.errorTest.push('個人資料蒐集、處理及利用告知事項');
    }

    if (this.errorTest.length || this.errorFormat.length) {
      this.dialogData.title = '提醒'
      this.privateType =0;
      this.visible = true;
      this.visibleType = '';
      if (this.errorTest.length) this.dialogData.message = this.errorTest.toString() + '為必填欄位。<br>'
      if (this.errorFormat.length) this.dialogData.message = this.dialogData.message + this.errorFormat.toString() + '欄位格式錯誤。'
    } else this.submit();
  }

  // 卡控申購組數
  validateInput(event: any) {
    const inputElement: HTMLInputElement = event.target;
    let inputValue: string = inputElement.value;
    // 整數正則式
    const regex = /^[1-9]\d*$/;
    if (!regex.test(inputValue)) {
      // 去除符號
      inputValue = inputValue.replace(/[^\d]/g, '');
      // 輸入0，重置默認1
      if (inputValue === "0") {
        inputValue = "1";
      }
      inputElement.value = inputValue;
    }
    // 更新 ngModel 綁訂
    this.request.PurchaseQuantity = parseInt(inputValue, 10);
  }

  refresh() {
    this.GetCaptchaImg();
  }

  submit() {
    if (!this.OrderTime) return;
    this.request.HandlingFee = this.ETFOrderFormInfo.HandlingFee;
    this.request.TransactionFee = this.ETFOrderFormInfo.TransactionFee;
    this.request.BrokerFee = this.ETFOrderFormInfo.BrokerFee;
    this.request.ETFRegisterID = this.ETFOrderFormInfo.ETFRegisterID;
    this.purchaseService.CreateOrder(this.request).subscribe((res) => {
      if (res.StatusCode == EnumStatusCode.Success) {
        if (this.isBrowser) document.getElementById('reset')?.click();
      }
      this.dialogOpen(res.Message);
      this.GetCaptchaImg();
      this.mainData$.loading$.next(false);
    })
  }

  dialogOpen(message: string, type?: string) {
    this.visibleType = '';
    this.visible = true;
    this.privateType = 0;
    this.dialogData.message = message;
     this.dialogData.title = '提醒'
    if (type=='agreeChecked') {
      this.visibleType = type;
      this.dialogData.title = '個人資料蒐集、處理及利用告知事項'
      this.privateType = 1;
    }
  }

  goTop() {
    if (this.isBrowser) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  //個資單篇文章
  GetArticleByID() {
    this.requestNew.FunctionID = 7343;
    this.requestNew.ID = 4;
    this.aritcleService.GetArticleByID(this.requestNew).subscribe((res) => {
      if (res.StatusCode == EnumStatusCode.Success) {
        this.aritcle = res.Entries;
      }
    });
  }

  unCheck(e: any) {
   // this.router.navigate(['/']);
  }

  // Tab切換事件
  selectTabChange(event: any) {
    this.activeIndex = event.index;

    // 根據當前選中的Tab索引更新對應的基金列表
    if (this.fundTypeList && this.fundTypeList.length > this.activeIndex) {
      const currentFundType = this.fundTypeList[this.activeIndex];

      // 更新當前顯示的基金列表
      this.canTradeFundList = this.fundListByType[currentFundType.Id] || [];
      this.selectedCanTradeFund = this.selectedFundByType[currentFundType.Id] || {} as GetFundSelectListRes;

      if (this.selectedCanTradeFund && this.selectedCanTradeFund.FundNo) {
        this.loadFundData(this.selectedCanTradeFund);
      }

      // 更新URL參數
      this.updateUrlParams();
    }
  }

  // 新的Tab選擇方法（用於自定義Tab）
  selectTab(index: number) {
    this.activeIndex = index;

    // 根據當前選中的Tab索引更新對應的基金列表
    if (this.fundTypeList && this.fundTypeList.length > this.activeIndex) {
      const currentFundType = this.fundTypeList[this.activeIndex];

      // 更新當前顯示的基金列表
      this.canTradeFundList = this.fundListByType[currentFundType.Id] || [];
      this.selectedCanTradeFund = this.selectedFundByType[currentFundType.Id] || {} as GetFundSelectListRes;

      if (this.selectedCanTradeFund && this.selectedCanTradeFund.FundNo) {
        this.loadFundData(this.selectedCanTradeFund);
      } else {
        // 即使沒有基金，也要更新URL
        this.updateUrlParams();
      }
    }
  }

  // 獲取有基金的基金類型列表
  GetFundTypeListWithAvailableFund() {
    console.log('開始載入基金類型列表...'); // 調試信息
    this.fundService.GetFundTypeListWithAvailableFund().subscribe((res) => {
      if (res.StatusCode == EnumStatusCode.Success) {
        this.fundTypeList = res.Entries.sort((a, b) => a.Sort - b.Sort);
        console.log('載入基金類型列表成功:', this.fundTypeList); // 調試信息

        // 載入每個基金類型的可交易基金
        this.fundTypeList.forEach((fundType) => {
          this.GetFundsByType(fundType.Id);
        });

        // 基金類型載入完成後，檢查URL參數
        this.checkAndApplyUrlParams();
      } else {
        console.error('獲取基金類型列表失敗:', res); // 調試信息
        // 如果 API 失敗，添加測試數據
        this.fundTypeList = [
          { Id: 1, Name: 'ETF小教室', Sort: 1, ParentID: 0 },
          { Id: 2, Name: 'ETF影音', Sort: 2, ParentID: 0 }
        ];
        console.log('使用測試數據:', this.fundTypeList);
        this.checkAndApplyUrlParams();
      }
    }, (error) => {
      console.error('API 呼叫錯誤:', error); // 調試信息
      // 如果 API 呼叫失敗，添加測試數據
      this.fundTypeList = [
        { Id: 1, Name: 'ETF小教室', Sort: 1, ParentID: 0 },
        { Id: 2, Name: 'ETF影音', Sort: 2, ParentID: 0 }
      ];
      console.log('API 錯誤，使用測試數據:', this.fundTypeList);
      this.checkAndApplyUrlParams();
    });
  }

  // 檢查並套用URL參數
  checkAndApplyUrlParams() {
    const currentParams = this.route.snapshot.queryParams;
    if (currentParams['typeId'] || currentParams['fundId']) {
      this.handleSubscriptionParams(currentParams);
    }
  }

  // 根據基金類型獲取基金列表
  GetFundsByType(typeId: number) {
    const request: GetFundSelectListReq = { TypeID: typeId };

    this.fundService.GetFundsByType(request).subscribe((res) => {
      if (res.StatusCode == EnumStatusCode.Success) {
        // 儲存該類型的基金列表
        this.fundListByType[typeId] = res.Entries;

        // 設定預設選擇的基金
        if (res.Entries.length > 0) {
          this.selectedFundByType[typeId] = res.Entries[0];
        }

        // 如果是當前激活的 Tab，更新顯示的基金列表
        const currentFundTypeIndex = this.fundTypeList.findIndex(ft => ft.Id === typeId);
        if (currentFundTypeIndex === this.activeIndex) {
          this.canTradeFundList = res.Entries;
          this.selectedCanTradeFund = res.Entries[0] || {} as GetFundSelectListRes;

          if (this.selectedCanTradeFund && this.selectedCanTradeFund.FundNo) {
            this.loadFundData(this.selectedCanTradeFund);
          } else {
            // 即使沒有基金，也要更新URL以顯示當前的Tab
            this.updateUrlParams();
          }
        }

        // 檢查是否所有基金類型的基金都已載入完成，如果是則套用URL參數
        this.checkAllFundsLoadedAndApplyParams();
      }
    });
  }

  // 檢查所有基金是否已載入完成，並套用URL參數
  checkAllFundsLoadedAndApplyParams() {
    const allTypesLoaded = this.fundTypeList.every(fundType =>
      this.fundListByType[fundType.Id] !== undefined
    );

    if (allTypesLoaded) {
      const currentParams = this.route.snapshot.queryParams;
      if (currentParams['typeId'] || currentParams['fundId']) {
        this.handleSubscriptionParams(currentParams);
      }
    }
  }

  // 載入基金資料的通用方法
 // loadFundData()
loadFundData(fund: GetFundSelectListRes) {
    if (fund && fund.FundNo) {
      this.FundNo = fund.FundNo;
      this.request.FundNo = fund.FundNo;
      this.PDreq.FundNo = fund.FundNo;

      // console.log('載入基金資料:', fund);
      // 重新獲取該基金的詳細資訊和券商資料
      this.GetPD();
      this.GetETFOrderFormInfo();

      // 更新URL參數
      this.updateUrlParams();
    }
  }

  // 基金選擇變更事件
  onCanTradeFundChange(event: any) {
    this.selectedCanTradeFund = event.value;

    // 同步更新對應Tab的選擇
    if (this.fundTypeList && this.fundTypeList.length > this.activeIndex) {
      const currentFundType = this.fundTypeList[this.activeIndex];
      this.selectedFundByType[currentFundType.Id] = event.value;
    }

    // 載入基金資料
    this.loadFundData(this.selectedCanTradeFund);

    // 更新URL參數
    this.updateUrlParams();
  }
}
